export type FacetKey =
  | 'brandId'
  | 'watchType'
  | 'occasion'
  | 'movementType'
  | 'caseMaterial'
  | 'dialColor';

export const FACET_LABELS: Record<FacetKey, string> = {
  brandId: 'Brand',
  watchType: 'Watch Type',
  occasion: 'Occasion',
  movementType: 'Movement Type',
  caseMaterial: 'Case Material',
  dialColor: 'Dial Color',
};

export interface FacetSelection {
  key: FacetKey;
  value: string;
}

/**
 * Algolia reads the outer array as AND and each inner array as OR, so every
 * selection of the same facet has to share one inner array. Giving each
 * selection its own inner array asks for a reference that is two brands at
 * once, which nothing satisfies.
 */
export function buildFacetFilters(selections: FacetSelection[]): string[][] {
  const grouped = new Map<FacetKey, string[]>();
  selections.forEach((s) => {
    if (!s.value) return;
    const group = grouped.get(s.key);
    if (group) group.push(`${s.key}:${s.value}`);
    else grouped.set(s.key, [`${s.key}:${s.value}`]);
  });
  return [...grouped.values()];
}
